export const SET_HRMS18E_INDEX_DISP = 'SET_HRMS18E_INDEX_DISP'
export const GET_HRMS18E_INDEX_DISP = 'GET_HRMS18E_INDEX_DISP'
export const SET_HRMS18E_DETAIL_DISP = 'SET_HRMS18E_DETAIL_DISP'
export const GET_HRMS18E_DETAIL_DISP = 'GET_HRMS18E_DETAIL_DISP'
export const SET_HRMS18E_UPDATE_COLUMNS_PARENT = 'SET_HRMS18E_UPDATE_COLUMNS_PARENT'
export const SET_HRMS18E_UPDATE_COLUMNS_CHILD = 'SET_HRMS18E_UPDATE_COLUMNS_CHILD'
export const SET_HRMS18E_COLUMNS = 'SET_HRMS18E_COLUMNS'
export const GET_HRMS18E_COLUMNS = 'GET_HRMS18E_COLUMNS'
export const SET_HRMS18E_LABELS = 'SET_HRMS18E_LABELS'
export const GET_HRMS18E_LABELS = 'GET_HRMS18E_LABELS'
export const SET_HRMS18E_SUM_DAY_IN_MONTH = 'SET_HRMS18E_SUM_DAY_IN_MONTH'
export const GET_HRMS18E_SUM_DAY_IN_MONTH = 'GET_HRMS18E_SUM_DAY_IN_MONTH'
export const GET_HRMS18E_SEARCH_INDEX = 'GET_HRMS18E_SEARCH_INDEX'
export const SET_HRMS18E_SEARCH_INDEX = 'SET_HRMS18E_SEARCH_INDEX'
export const RECEIVED_HRMS18E_COLUMNS_LABELS = 'RECEIVED_HRMS18E_COLUMNS_LABELS'
export const GET_HRMS18E_INDEX = 'GET_HRMS18E_INDEX'
export const SET_HRMS18E_INDEX_PARENT = 'SET_HRMS18E_INDEX_PARENT'
export const SET_HRMS18E_INDEX_CHILD = 'SET_HRMS18E_INDEX_CHILD'
export const SET_HRMS18E_INDEX_CHILD_BY_PARENT = 'SET_HRMS18E_INDEX_CHILD_BY_PARENT'
export const RECEIVED_HRMS18E_INDEX = 'RECEIVED_HRMS18E_INDEX'
export const GET_HRMS18E_CURRENT_TYPEWORK_PARENT = 'GET_HRMS18E_CURRENT_TYPEWORK_PARENT'
export const SET_HRMS18E_CURRENT_TYPEWORK_PARENT = 'SET_HRMS18E_CURRENT_TYPEWORK_PARENT'
export const GET_HRMS18E_TARGET_TYPEWORK_PARENT = 'GET_HRMS18E_TARGET_TYPEWORK_PARENT'
export const SET_HRMS18E_TARGET_TYPEWORK_PARENT = 'SET_HRMS18E_TARGET_TYPEWORK_PARENT'
export const GET_HRMS18E_CURRENT_CODSHIFT_PARENT = 'GET_HRMS18E_CURRENT_CODSHIFT_PARENT'
export const SET_HRMS18E_CURRENT_CODSHIFT_PARENT = 'SET_HRMS18E_CURRENT_CODSHIFT_PARENT'
export const GET_HRMS18E_TARGET_CODSHIFT_PARENT = 'GET_HRMS18E_TARGET_CODSHIFT_PARENT'
export const SET_HRMS18E_TARGET_CODSHIFT_PARENT = 'SET_HRMS18E_TARGET_CODSHIFT_PARENT'
export const GET_HRMS18E_TARGET_CODCALEN_PARENT = 'GET_HRMS18E_TARGET_CODCALEN_PARENT'
export const SET_HRMS18E_TARGET_CODCALEN_PARENT = 'SET_HRMS18E_TARGET_CODCALEN_PARENT'
export const SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_PARENT = 'SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_PARENT'
export const SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_PARENT = 'SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_PARENT'
export const GET_HRMS18E_INLINE_DATA_PARENT = 'GET_HRMS18E_INLINE_DATA_PARENT'
export const SET_HRMS18E_INLINE_DATA_PARENT = 'SET_HRMS18E_INLINE_DATA_PARENT'
export const POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_PARENT = 'POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_PARENT'
export const GET_HRMS18E_CURRENT_TYPEWORK_CHILD = 'GET_HRMS18E_CURRENT_TYPEWORK_CHILD'
export const SET_HRMS18E_CURRENT_TYPEWORK_CHILD = 'SET_HRMS18E_CURRENT_TYPEWORK_CHILD'
export const GET_HRMS18E_TARGET_TYPEWORK_CHILD = 'GET_HRMS18E_TARGET_TYPEWORK_CHILD'
export const SET_HRMS18E_TARGET_TYPEWORK_CHILD = 'SET_HRMS18E_TARGET_TYPEWORK_CHILD'
export const GET_HRMS18E_CURRENT_CODSHIFT_CHILD = 'GET_HRMS18E_CURRENT_CODSHIFT_CHILD'
export const SET_HRMS18E_CURRENT_CODSHIFT_CHILD = 'SET_HRMS18E_CURRENT_CODSHIFT_CHILD'
export const GET_HRMS18E_TARGET_CODSHIFT_CHILD = 'GET_HRMS18E_TARGET_CODSHIFT_CHILD'
export const SET_HRMS18E_TARGET_CODSHIFT_CHILD = 'SET_HRMS18E_TARGET_CODSHIFT_CHILD'
export const GET_HRMS18E_TARGET_CODEMPID_CHILD = 'GET_HRMS18E_TARGET_CODEMPID_CHILD'
export const SET_HRMS18E_TARGET_CODEMPID_CHILD = 'SET_HRMS18E_TARGET_CODEMPID_CHILD'
export const SET_HRMS18E_ADDED_DATA_ROW_CHILD = 'SET_HRMS18E_ADDED_DATA_ROW_CHILD'
export const SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_CHILD = 'SET_HRMS18E_TYPEWORK_TO_TARGET_TYPEWORK_CHILD'
export const SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_CHILD = 'SET_HRMS18E_CODSHIFT_TO_TARGET_CODSHIFT_CHILD'
export const SET_HRMS18E_ADD_INLINE_CODEMPID_CHILD = 'SET_HRMS18E_ADD_INLINE_CODEMPID_CHILD'
export const GET_HRMS18E_INLINE_DATA_CHILD = 'GET_HRMS18E_INLINE_DATA_CHILD'
export const SET_HRMS18E_INLINE_DATA_CHILD = 'SET_HRMS18E_INLINE_DATA_CHILD'
export const POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_CHILD = 'POST_HRMS18E_TYPEWORK_CODSHIFT_ON_PERIOD_CHILD'
export const POST_HRMS18E_INDEX_SAVE = 'POST_HRMS18E_INDEX_SAVE'
export const GET_HRMS18E_CURRENT_DAY_PARENT = 'GET_HRMS18E_CURRENT_DAY_PARENT'
export const SET_HRMS18E_CURRENT_DAY_PARENT = 'SET_HRMS18E_CURRENT_DAY_PARENT'
export const GET_HRMS18E_CURRENT_DAY_CHILD = 'GET_HRMS18E_CURRENT_DAY_CHILD'
export const SET_HRMS18E_CURRENT_DAY_CHILD = 'SET_HRMS18E_CURRENT_DAY_CHILD'
export const GET_HRMS18E_TRADITIONAL_DAYS = 'GET_HRMS18E_TRADITIONAL_DAYS'
export const SET_HRMS18E_TRADITIONAL_DAYS = 'SET_HRMS18E_TRADITIONAL_DAYS'
export const GET_HRMS18E_SHUTDOWN_DAYS = 'GET_HRMS18E_SHUTDOWN_DAYS'
export const SET_HRMS18E_SHUTDOWN_DAYS = 'SET_HRMS18E_SHUTDOWN_DAYS'
export const RECEIVED_HRMS18E_TRADITIONAL_AND_SHUTDOWN_DAYS = 'RECEIVED_HRMS18E_TRADITIONAL_AND_SHUTDOWN_DAYS'



// WEBPACK FOOTER //
// ./src/store/modules/hrms18e/mutation-types.js